import React, { useState } from 'react';
import { FaArrowRight, FaStar, FaHeart, FaShare, FaMapMarkerAlt, FaPhone, FaClock } from 'react-icons/fa';

const Collections = () => {
  const [activeFilter, setActiveFilter] = useState('All');

  const collections = [
    {
      id: 1,
      name: 'Premium Curtains Collection',
      description: 'Elegant curtains crafted from premium fabrics to enhance your living spaces',
      image: 'https://billionfire.com/wp-content/uploads/2025/01/image-66.png',
      fullImage: 'https://billionfire.com/wp-content/uploads/2025/01/image-66.png',
      items: '45 items',
      category: 'Curtains',
      rating: 4.8,
      featured: true
    },
    {
      id: 2,
      name: 'Luxury Bedsheets Collection',
      description: 'Soft and comfortable bedsheets made from high-quality cotton and silk',
      image: 'https://th.bing.com/th/id/R.0a348fcfe46078bd75473cec9abe2450?rik=OH4CJEaCXHrv6g&riu=http%3a%2f%2fcdn.shopify.com%2fs%2ffiles%2f1%2f0549%2f2532%2f8602%2fproducts%2f1_f4eb8e98-93f2-4c88-ab79-9537a727b8b1.jpg%3fv%3d1656052002&ehk=AlzOFG90qU6FnvmHIkB%2fRp0xWtjd4E0TysigjdEjGfk%3d&risl=&pid=ImgRaw&r=0',
      fullImage: 'https://th.bing.com/th/id/R.0a348fcfe46078bd75473cec9abe2450?rik=OH4CJEaCXHrv6g&riu=http%3a%2f%2fcdn.shopify.com%2fs%2ffiles%2f1%2f0549%2f2532%2f8602%2fproducts%2f1_f4eb8e98-93f2-4c88-ab79-9537a727b8b1.jpg%3fv%3d1656052002&ehk=AlzOFG90qU6FnvmHIkB%2fRp0xWtjd4E0TysigjdEjGfk%3d&risl=&pid=ImgRaw&r=0',
      items: '38 items',
      category: 'Bedsheets',
      rating: 4.9,
      featured: true
    },
    {
      id: 3,
      name: 'Designer Wallpapers Collection',
      description: 'Transform your walls with our exclusive range of designer wallpapers',
      image: 'https://buildingandinteriors.com/wp-content/uploads/2022/06/Living-room-wallpaper-ideas_Floral-pink-wallpaper_Sanderson.webp',
      fullImage: 'https://buildingandinteriors.com/wp-content/uploads/2022/06/Living-room-wallpaper-ideas_Floral-pink-wallpaper_Sanderson.webp',
      items: '52 items',
      category: 'Wallpapers',
      rating: 4.7,
      featured: true
    },
    {
      id: 4,
      name: 'Orthopedic Mattresses Collection',
      description: 'Premium mattresses for a comfortable and healthy sleep',
      image: 'https://m.media-amazon.com/images/I/81HvSmy-AuL._SL1500_.jpg',
      fullImage: 'https://m.media-amazon.com/images/I/81HvSmy-AuL._SL1500_.jpg',
      items: '33 items',
      category: 'Mattresses',
      rating: 4.9,
      featured: true
    },
    {
      id: 5,
      name: 'Modern Blinds Collection',
      description: 'Stylish blinds to control light and add privacy to your rooms',
      image: 'https://expressionblinds.co.uk/wp-content/uploads/2018/08/Anthracite-2.jpeg',
      fullImage: 'https://expressionblinds.co.uk/wp-content/uploads/2018/08/Anthracite-2.jpeg',
      items: '41 items',
      category: 'Blinds',
      rating: 4.6,
      featured: false
    },
    {
      id: 6,
      name: 'Handwoven Rugs Collection',
      description: 'Beautiful rugs to add warmth and style to your floors',
      image: 'https://st3.depositphotos.com/19132704/36209/i/1600/depositphotos_362094790-stock-photo-illustrated-persian-carpet-original-design.jpg',
      fullImage: 'https://st3.depositphotos.com/19132704/36209/i/1600/depositphotos_362094790-stock-photo-illustrated-persian-carpet-original-design.jpg',
      items: '29 items',
      category: 'Rugs',
      rating: 4.8,
      featured: true
    },
    {
      id: 7,
      name: 'Premium Towels Collection',
      description: 'Soft and absorbent towels for your bathroom',
      image: 'https://tse4.mm.bing.net/th/id/OIP.99CuGfNf3spgLITqqVY7egHaGn?rs=1&pid=ImgDetMain&o=7&rm=3',
      fullImage: 'https://tse4.mm.bing.net/th/id/OIP.99CuGfNf3spgLITqqVY7egHaGn?rs=1&pid=ImgDetMain&o=7&rm=3',
      items: '27 items',
      category: 'Towels',
      rating: 4.5,
      featured: false
    },
    {
      id: 8,
      name: 'Home Decoratives Collection',
      description: 'Add character to your home with our beautiful decor items',
      image: 'https://i.pinimg.com/736x/c4/25/f1/c425f10ccc7e7a8094636cf49fc01602.jpg',
      fullImage: 'https://i.pinimg.com/736x/c4/25/f1/c425f10ccc7e7a8094636cf49fc01602.jpg',
      items: '34 items',
      category: 'Decoratives',
      rating: 4.7,
      featured: false
    },
    {
      id: 9,
      name: 'Upholstery Fabrics Collection',
      description: 'Premium fabrics for all your furniture upholstery needs',
      image: 'https://fabricinnovations.com/cdn/shop/files/COTE_D_AZUR_1800x.jpg?v=1702901887',
      fullImage: 'https://fabricinnovations.com/cdn/shop/files/COTE_D_AZUR_1800x.jpg?v=1702901887',
      items: '23 items',
      category: 'Upholstery',
      rating: 4.9,
      featured: true
    }
  ];

  const filters = ['All', 'Curtains', 'Bedsheets', 'Wallpapers', 'Mattresses', 'Blinds', 'Rugs', 'Towels', 'Decoratives', 'Upholstery'];

  const filteredCollections = activeFilter === 'All' 
    ? collections 
    : collections.filter(c => c.category === activeFilter);

  // Function to handle image click - opens full image
  const handleImageClick = (imageUrl) => {
    window.open(imageUrl, '_blank');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="relative h-[500px] overflow-hidden">
        <img 
          src="https://images.unsplash.com/photo-1566737236500-c8ac43014a67?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80" 
          alt="Varanasi Ghats"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-pink-900/80 to-blue-900/80"></div>
        
        <div className="absolute inset-0 flex items-center justify-center text-center">
          <div className="max-w-4xl mx-auto px-4">
            <div className="inline-block px-4 py-1 bg-white/10 backdrop-blur-sm rounded-full text-pink-200 text-sm mb-6 animate-fade-in">
              Home Fashion Varanasi
            </div>
            <h1 className="text-5xl md:text-7xl font-bold text-white mb-4 animate-fade-in animation-delay-200">
              Our Collections
            </h1>
            <p className="text-xl text-white/90 max-w-2xl mx-auto animate-fade-in animation-delay-400">
              Discover our exclusive range of home furnishings at Rathyatra-Mahmmoorganj Road, Varanasi
            </p>
            
            {/* Contact Info */}
            <div className="flex justify-center gap-6 mt-8 animate-fade-in animation-delay-600">
              <div className="flex items-center gap-2 text-white/80">
                <FaPhone className="text-pink-300" size={14} />
                <span className="text-sm">8573035759</span>
              </div>
              <div className="flex items-center gap-2 text-white/80">
                <FaMapMarkerAlt className="text-pink-300" size={14} />
                <span className="text-sm">Rathyatra-Mahmmoorganj Road</span>
              </div>
            </div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center">
            <div className="w-1 h-3 bg-white rounded-full mt-2 animate-scroll"></div>
          </div>
        </div>
      </div>

      {/* Filters Section */}
      <div className="container mx-auto px-4 py-12">
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {filters.map((filter) => (
            <button
              key={filter}
              onClick={() => setActiveFilter(filter)}
              className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
                activeFilter === filter
                  ? 'bg-gradient-to-r from-pink-500 to-blue-500 text-white shadow-lg scale-105'
                  : 'bg-white text-gray-600 hover:text-pink-500 shadow hover:shadow-md'
              }`}
            >
              {filter}
            </button>
          ))}
        </div>

        {/* Collections Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredCollections.map((collection) => (
            <div 
              key={collection.id} 
              className="group relative bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2"
            >
              {/* Featured Badge */}
              {collection.featured && (
                <div className="absolute top-4 left-4 z-20">
                  <div className="bg-gradient-to-r from-yellow-400 to-yellow-500 text-white px-3 py-1 rounded-full text-xs font-semibold shadow-lg flex items-center gap-1">
                    <FaStar className="text-white" size={10} />
                    Featured
                  </div>
                </div>
              )}

              {/* Image Container - FULL SIZE IMAGE */}
              <div 
                className="relative h-80 overflow-hidden cursor-pointer" // Increased from h-64 to h-80
                onClick={() => handleImageClick(collection.fullImage)}
              >
                <img 
                  src={collection.image} 
                  alt={collection.name}
                  className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = 'https://via.placeholder.com/600x400?text=Collection+Image';
                  }}
                />
                {/* PURE IMAGE - NO OVERLAY */}
              </div>
              
              {/* Content */}
              <div className="p-5">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="text-xl font-bold text-gray-800 group-hover:text-pink-500 transition-colors duration-300">
                    {collection.name}
                  </h3>
                  <div className="flex items-center gap-1">
                    <FaStar className="text-yellow-400" size={14} />
                    <span className="text-sm font-semibold text-gray-700">{collection.rating}</span>
                  </div>
                </div>
                
                <p className="text-gray-600 text-sm mb-3 line-clamp-2">
                  {collection.description}
                </p>
                
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center gap-2">
                    <span className="text-xs text-gray-500">Available:</span>
                    <span className="text-sm font-semibold text-pink-500">{collection.items}</span>
                  </div>
                  <div className="text-lg font-bold text-gray-800">{collection.price}</div>
                </div>
                
                <button className="w-full py-3 flex items-center justify-center gap-2 bg-gradient-to-r from-pink-500 to-blue-500 text-white rounded-xl font-semibold hover:shadow-lg transform hover:scale-105 transition-all duration-300 group/btn">
                  <span>Explore Collection</span>
                  <FaArrowRight className="group-hover/btn:translate-x-2 transition-transform duration-300" />
                </button>
              </div>
              
              {/* Hover Border Effect */}
              <div className="absolute inset-0 border-2 border-transparent group-hover:border-pink-500 rounded-2xl transition-all duration-300 pointer-events-none"></div>
            </div>
          ))}
        </div>

        {/* Load More Button */}
        <div className="text-center mt-12">
          <button className="px-8 py-3 bg-white text-pink-500 rounded-full font-semibold shadow-md hover:shadow-xl transition-all duration-300 transform hover:scale-105 border-2 border-pink-500 hover:bg-pink-500 hover:text-white">
            Load More Collections
          </button>
        </div>

        {/* Featured Collection - Varanasi Special */}
        <div className="mt-20 bg-gradient-to-r from-pink-500 to-blue-500 rounded-3xl p-8 md:p-12 relative overflow-hidden">
          {/* Decorative Elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full -mr-32 -mt-32 animate-pulse"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/10 rounded-full -ml-24 -mb-24 animate-pulse delay-700"></div>
          
          <div className="relative grid md:grid-cols-2 gap-8 items-center">
            <div className="text-white">
              <div className="inline-block px-4 py-1 bg-white/20 backdrop-blur-sm rounded-full text-sm mb-4">
                Rathyatra Special
              </div>
              <h2 className="text-3xl md:text-4xl font-bold mb-4">Varanasi Exclusive Collection</h2>
              <p className="text-base md:text-lg mb-6 opacity-90 leading-relaxed">
                Handcrafted by local artisans using traditional techniques. Available exclusively at our Rathyatra-Mahmmoorganj Road showroom.
              </p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-center gap-3">
                  <span className="w-2 h-2 bg-yellow-300 rounded-full"></span>
                  <span>Hand-carved wooden furniture</span>
                </li>
                <li className="flex items-center gap-3">
                  <span className="w-2 h-2 bg-yellow-300 rounded-full"></span>
                  <span>Authentic Banarasi silk upholstery</span>
                </li>
                <li className="flex items-center gap-3">
                  <span className="w-2 h-2 bg-yellow-300 rounded-full"></span>
                  <span>Brass inlay work by local craftsmen</span>
                </li>
              </ul>
              <button className="px-6 py-3 bg-white text-pink-500 rounded-full font-semibold hover:shadow-2xl transform hover:scale-105 transition-all duration-300 flex items-center gap-2">
                View Special Collection <FaArrowRight />
              </button>
            </div>
            <div 
              className="relative h-96 rounded-2xl overflow-hidden shadow-2xl transform hover:scale-105 transition-transform duration-500 cursor-pointer" // Increased height
              onClick={() => window.open('https://images.unsplash.com/photo-1586023492125-27b2c045efd7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', '_blank')}
            >
              <img 
                src="https://images.unsplash.com/photo-1586023492125-27b2c045efd7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
                alt="Varanasi Special Collection"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>

        {/* Visit Us Banner */}
        <div className="mt-20 bg-gray-900 text-white rounded-3xl p-10 text-center relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-pink-500/10 to-blue-500/10"></div>
          <div className="relative">
            <h3 className="text-3xl md:text-4xl font-bold mb-4">Visit Our Showroom in Varanasi</h3>
            <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-10 mb-6">
              <div className="flex items-center gap-3">
                <FaMapMarkerAlt className="text-pink-400 text-xl" />
                <p className="text-gray-300">Rathyatra-Mahmmoorganj Road, Varanasi - 221010</p>
              </div>
              <div className="flex items-center gap-3">
                <FaPhone className="text-pink-400 text-xl" />
                <p className="text-pink-400 font-semibold text-xl">8573035759</p>
              </div>
              <div className="flex items-center gap-3">
                <FaClock className="text-pink-400 text-xl" />
                <p className="text-gray-300">Mon-Sat: 10am - 8pm</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Custom Animations */}
      <style jsx>{`
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes scroll {
          0% { transform: translateY(0); opacity: 1; }
          100% { transform: translateY(20px); opacity: 0; }
        }
        
        .animate-fade-in {
          animation: fade-in 0.8s ease-out forwards;
        }
        .animate-scroll {
          animation: scroll 2s infinite;
        }
        .animation-delay-200 {
          animation-delay: 0.2s;
          opacity: 0;
        }
        .animation-delay-400 {
          animation-delay: 0.4s;
          opacity: 0;
        }
        .animation-delay-600 {
          animation-delay: 0.6s;
          opacity: 0;
        }
        .delay-700 {
          animation-delay: 0.7s;
        }
      `}</style>
    </div>
  );
};

export default Collections;